let filters = document.querySelector('.filter-holder');
let filtersOpen = document.querySelector('.js-open-filters');
let filtersClose = document.querySelectorAll('.js-close-filters');
filtersOpen.addEventListener('click', openFilters);

for (let i = 0; i < filtersClose.length; i++) {
    filtersClose[i].addEventListener('click', closeFilters);
}

function openFilters() {
    filters.classList.add('open');
    document.body.classList.add('filters-open');
}

function closeFilters() {
    filters.classList.remove('open');
    document.body.classList.remove('filters-open');
}

let jsCategories = document.querySelectorAll('.js-categories');

jsCategories.forEach(function (el) {
    el.addEventListener('click', function () {
        jsCategories.forEach(function (item) {
            item.classList.remove('js-open');
        });

        this.classList.add('js-open');
    });
});

let jsRadioTypes = document.querySelectorAll('.disciplines input');
let jsMse2RadioTypes = document.querySelectorAll('#mse2_resource--parent input');
let jsDownloadBox = document.querySelector('.block_hero_course .download');
let jsDownloadButton = document.querySelector('.block_hero_course .download a.button');

jsRadioTypes.forEach(function (el) {
    el.addEventListener('click', function () {
        var thisChecked = false;
        var thisValue = this.value;

        if (this.checked === true) {
            thisChecked = true;
        }

        /* siblings fields */
        jsRadioTypes.forEach(function (sibling) {
            sibling.checked = false;
        });

        /* hidden mse2 fields */
        jsMse2RadioTypes.forEach(function (item) {
            if (thisValue == item.value) {
                item.click();
            }
        });

        /* swapped states because checked is faster than click */
        if (thisChecked) {
            el.checked = true;

            if (this.dataset.download) {
                jsDownloadBox.classList.remove('hide');
                jsDownloadButton.setAttribute('href', this.dataset.download);
                jsDownloadButton.setAttribute('data-download', this.value);
            }else{
                jsDownloadBox.classList.add('hide');
            }

        } else {
            el.checked = false;

            if (this.dataset.download && jsDownloadBox) {
                jsDownloadBox.classList.add('hide');
            }

            jsMse2RadioTypes.forEach(function (item) {
                if (thisValue == item.value) {
                    item.checked = false;
                    mSearch2.submit();
                }
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    let jsRadioTypes = document.querySelectorAll('.disciplines input');

    if (jsRadioTypes) {
        jsRadioTypes.forEach(function (item) {
            if (item.checked === true) {
                item.parentElement.parentElement.parentElement.parentElement.querySelector('.js-categories').classList.add('js-open');
            }
        });
    }
});